import { makeStyles } from 'tss-react/mui';

const useStylesLabels = makeStyles()((theme) => {
    return {
        root: {
            '& .MuiOutlinedInput-root': {
                borderRadius: theme.spacing(2),
                '& > fieldset': {
                    borderColor: '#E2E2E2',
                },
            },
            '& .MuiAutocomplete-input': {
                padding: '0 !important',
                margin: theme.spacing(1.5),
            },
            '& input': {
                paddingLeft: theme.spacing(1),
                paddingTop: '0 !important',
                fontSize: '0.75rem',
                fontWeight: '500',
                position: 'relative',
                '&:focus': {
                    borderRadius: 5,
                },
                '& > fieldset': {
                    borderColor: '#E2E2E2',
                },
                [theme.breakpoints.up('xl')]: {
                    fontSize: '14px',
                    height: '26px',
                },
            },
        },
        sizeSmall: {
            width: theme.spacing(40),
            marginRight: theme.spacing(2),
            '& .MuiAutocomplete-input': {
                padding: '0 !important',
                margin: '2px 0px 2px 8px',
                // [theme.breakpoints.up('xl')]: {
                //     padding: '0!important',
                //     margin: theme.spacing(0.5),
                // },
            },
            '& .MuiOutlinedInput-root': {
                height: theme.spacing(3),
                border: '1px solid #DEDEDE',
                borderRadius: theme.spacing(2),
                padding: '0 !important',
            },
        },
        sizeMedium: {
            width: theme.spacing(40),
            marginRight: theme.spacing(2),
            '& .MuiAutocomplete-input': {
                padding: '0 !important',
                margin: theme.spacing(1),
                minHeight: theme.spacing(2)
                // [theme.breakpoints.up('xl')]: {
                //     padding: '0!important',
                //     margin: theme.spacing(0.5),
                // },
            },
            '& .MuiOutlinedInput-root': {
                minHeight: theme.spacing(4),
                border: '0px solid #DEDEDE',
                borderRadius: theme.spacing(2),
                padding: '0 !important',
            },

            '& .MuiAutocomplete-tag': {
                height: theme.spacing(3),
            },
            '& .MuiChip-deleteIcon': {
                fontSize: theme.spacing(2),
            }
        },
        option: {
            backgroundColor: theme.palette.background.paper + '!important',
            height: theme.spacing(5),
            // '&.selected': {
            //     backgroundColor: 'rgba(255, 0, 0, 0.12) !important'
            // }
        },
        listBox: {
            maxHeight: theme.spacing(30),
            overflowX: 'hidden',
        },
    };
});

export default useStylesLabels;
